module.exports = __webpack_public_path__ + "img/BANNER_RITUAL_MOBILE.8afe25fa.png";